import { parse, stringify } from "query-string";
import React from "react";

import { bazaarUrl } from "@/mk2/apps/bazaar/urls";
import { SignupLoginWrapper } from "@/mk2/apps/users/components/SignupLoginWrapper";
import { SignupForm } from "@/mk2/apps/users/containers/Signup/SignupForm";
import { Props } from "@/mk2/apps/users/containers/Signup/SignupPage";
import { signupUrl } from "@/mk2/apps/users/urls";
import { FormPageType } from "@/mk2/constants/enums";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { GetParams } from "@/mk2/helpers/urls";
import { replaceInPWA } from "@/mk2/services/browserHistory";
import { isAuthenticated } from "@/mk/bazaar/common/userUtils";

import styles from "./Signup.mscss";

const STEP_VS_FORMPAGE_MAPPING = {
    1: FormPageType.Main,
    2: FormPageType.SignupPhoneVerification,
    3: FormPageType.SignupTokenValidation,
    4: FormPageType.SignupPhotoUpload,
};

export default class Signup extends React.Component<Props> {
    public UNSAFE_componentWillMount() {
        const { requestUser, location, routeNavigate } = this.props;
        if (isAuthenticated(requestUser)) {
            const nextPageUrl = (parse(location.search).next as string) || bazaarUrl;
            replaceInPWA(routeNavigate, { pathname: nextPageUrl });
        }
    }

    public UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const {
            location: { search },
            routeNavigate,
            currentFormPage,
            onOpenFormPage,
            currentValues,
        } = nextProps;

        if (currentValues !== undefined && currentFormPage !== undefined) {
            const qs = parse(search, { parseNumbers: true }) || {};
            let step = (qs.step as number) || 1;

            if (
                (step > 1 &&
                    !(currentValues.username && currentValues.password && currentValues.email)) ||
                (step > 2 && !currentValues.fullPhoneNumber) ||
                (step > 3 && !currentValues.token)
            ) {
                step = 1;
                qs.step = step;
                replaceInPWA(routeNavigate, {
                    pathname: signupUrl,
                    search: stringify(qs, { skipNull: true }),
                });
            }

            if (STEP_VS_FORMPAGE_MAPPING[step] !== currentFormPage) {
                onOpenFormPage(STEP_VS_FORMPAGE_MAPPING[step]);
            }
        }
    }

    public render() {
        const {
            avatar,
            contentItemsKey,
            contentItemBottom,
            contentItemTop,
            currentFormPage,
            currentValues,
            initialValues,
            loadingState,
            isMobile,
            query,
            location,
            onPrepareUploadPhotos,
            onStoreEvent,
            onPhoneVerificationRequestToken,
            onPhoneVerificationValidateToken,
        } = this.props;

        return (
            <SignupLoginWrapper
                className={styles.Signup}
                query={query as GetParams}
                isMobile={isMobile}
                currentFormPage={currentFormPage}
                contentItemsKey={contentItemsKey}
                contentItemTop={contentItemTop}
                contentItemBottom={contentItemBottom}
                location={location}
            >
                <LoadingSwitch
                    loadingState={loadingState}
                    hasData={contentItemTop !== undefined}
                    onLoad={this.handleOnLoad}
                    onRenderInit={this.renderNothing}
                    onRenderSuccess={this.renderNothing}
                    onRenderFailure={this.renderNothing}
                />

                <SignupForm
                    onStoreEvent={onStoreEvent}
                    query={query}
                    isMobile={isMobile}
                    onSignup={this.handleSignup}
                    onValidateInputs={this.handleValidateInputs}
                    initialValues={initialValues}
                    currentValues={currentValues}
                    onPhoneVerificationRequestToken={onPhoneVerificationRequestToken}
                    onPhoneVerificationValidateToken={onPhoneVerificationValidateToken}
                    onPrepareUploadPhotos={onPrepareUploadPhotos}
                    avatar={avatar}
                    location={location}
                />
            </SignupLoginWrapper>
        );
    }

    private renderNothing = () => null;

    private handleOnLoad = () => {
        const { contentItemsKey, onLoad, location } = this.props;
        onLoad(contentItemsKey, location);
    };

    private handleSignup = (values) => {
        const { query, onSignup, location } = this.props;
        onSignup(values, query, location);
    };

    private handleValidateInputs = (values) => {
        const { query, onValidateInputs, location } = this.props;
        onValidateInputs(values, query, location);
    };
}
